import 'ace-builds';
import AceEditor from 'react-ace';
import React, { useCallback } from 'react';
import 'ace-builds/webpack-resolver';
import 'ace-builds/src-noconflict/theme-tomorrow';

function CodeEditor({ value, name, onChange, mode = 'html' }) {
    const handleChange = useCallback(
        (newValue) => {
            onChange({ value: newValue, name });
        },
        [name, onChange]
    );

    return (
        <AceEditor
            mode={mode}
            name={name}
            value={value}
            theme="tomorrow"
            showGutter={false}
            placeholder="Write or copy your custom code here..."
            style={{
                height: 220,
                width: '100%',
                borderRadius: '5px',
                border: '1px solid #e5ebf0',
            }}
            onChange={handleChange}
            editorProps={{ $blockScrolling: true }}
            setOptions={{
                showLineNumbers: false,
            }}
        />
    );
}

export default CodeEditor;
